import fetch from '@/utils/fetch'

export function page (data) {
  return fetch({
    url: '/ows/trip/order/ow-order-page',
    method: 'post',
    data
  })
}

export function getDetail (orderNo) {
  return fetch({
    url: '/ows/trip/order/ow-order-info/' + orderNo,
    method: 'post'
  })
}

export function getTicketDetail (data) {
  return fetch({
    url: '/api/query/list',
    method: 'post',
    data
  })
}

// 检票记录
export function getCheckLogList (ticketId) {
  return fetch({
    url: '/check/ticket/log/list-by-ticket-id/' + ticketId,
    method: 'POST'
  })
}

export function getTicketInfo (data) {
  return fetch({
    url: '/api/integration/get-ticket-for-refund',
    method: 'POST',
    data
  })
}

export function ticketRefund (data) {
  return fetch({
    url: '/api/integration/refund',
    method: 'POST',
    data
  })
}

// 支付查询
export function PayForTheQuery (orderNo) {
  return fetch({
    url: `/pay/jsapi/check-unpaid/${orderNo}`,
    method: 'post'
  })
}

// 查询可改签票信息
export function findRebook (data) {
  return fetch({
    url: '/api/integration/pc-find-for-rebook',
    method: 'post',
    data
  })
}

// 改签票接口
export function canReBook (data) {
  return fetch({
    url: '/api/integration/pc-rebook',
    method: 'post',
    data
  })
}

export function isCanRebook () {
  return fetch({
    url: '/bms/sys-config/info-by-code/IS_CAN_REBOOK',
    method: 'post'
  })
}

export function loadList (data) {
  let url = '/website/hotel/order/page'
  if (data.orderCat === 'FOOD') {
    url = '/website/food/order/page'
  } else if (data.orderCat === 'RETAIL') {
    url = '/website/retail/order/page'
  } else if (data.orderCat === 'PACKAGES') {
    url = '/website/packages/order/page'
  }
  return fetch({
    url,
    method: 'post',
    data
  })
}

export function loadDetail (orderNo, moduleType) {
  let url = `/website/hotel/order/detail/${orderNo}`
  if (moduleType === 'FOOD') {
    url = `/website/food/order/order-detail/${orderNo}`
  } else if (moduleType === 'RETAIL') {
    url = `/website/retail/order/${orderNo}/info`
  } else if (moduleType === 'PACKAGES') {
    url = `/website/packages/order/detail/${orderNo}`
  }
  return fetch({
    url,
    method: 'post'
  })
}

export function loadRefundData (data) {
  let url = '/website/packages/order/get-ticket-for-refund'
  return fetch({
    url,
    method: 'post',
    data
  })
}

export function refund (data, moduleType) {
  let url = `/website/hotel/order/refund/refund`
  if (moduleType === 'FOOD') {
    url = `/website/food/order/refund/refund`
  } else if (moduleType === 'PACKAGES') {
    url = '/website/packages/order/refund'
  }
  return fetch({
    url,
    method: 'post',
    data
  })
}

export function loadBedType () {
  return fetch({
    url: '/comm/dict/list/bedType',
    method: 'post'
  })
}

// 提交评价
export function saveReview (data) {
  return fetch({
    url: '/website/order-review/save',
    method: 'post',
    data
  })
}

// 获取评价
export function getReview (orderNo) {
  return fetch({
    url: `website/order-review/info/${orderNo}`,
    method: 'post'
  })
}

export function getShippingList (uniteOrderNo) {
  return fetch({
    url: `/website/retail/order/${uniteOrderNo}/shipping-list`,
    method: 'post'
  })
}

export function getTransitStep (data) {
  return fetch({
    url: `/website/retail/aftersales/transit-step`,
    method: 'post',
    data
  })
}